import { render, staticRenderFns } from "./BudgetLineDeclareForm.vue?vue&type=template&id=b81f42a6"
import script from "./BudgetLineDeclareForm.vue?vue&type=script&lang=js"
export * from "./BudgetLineDeclareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports